// utils/networkSpeed.ts

const TEST_FILE_URL = '/speed-test-file.txt';
const TEST_FILE_SIZE_BYTES = 1048576; // 1MB

/**
 * Measures the user's download speed in Mbps.
 * @returns {Promise<number>} The download speed in Mbps.
 */
export const measureDownloadSpeed = async (): Promise<number> => {
  try {
    const startTime = new Date().getTime();
    
    const response = await fetch(TEST_FILE_URL, { cache: 'no-store' });
    if (!response.ok) {
      console.error('Speed test failed: Non-OK response', response);
      throw new Error(`Failed to download test file: ${response.statusText}`);
    }
    
    await response.blob();
    
    const endTime = new Date().getTime();
    const durationSeconds = (endTime - startTime) / 1000;
    
    if (durationSeconds === 0) {
      return Infinity; // Or handle as a special case
    }
    
    const speedBps = (TEST_FILE_SIZE_BYTES * 8) / durationSeconds;
    const speedMbps = speedBps / 1000000;
    
    return speedMbps;
  } catch (error) {
    console.error('Speed test failed with error:', error);
    throw error;
  }
};
